export default __webpack_public_path__ + "static/media/caixa-preta.c02057af.svg";